// extracted by mini-css-extract-plugin
module.exports = {"AppHeader":"AppHeader_EgBTF"};